import React from "react";

const SubscriptionPlanSkeleton: React.FC = () => {
  return (
    <div className="subscription-plan subscription-plan--skeleton" aria-hidden>
      <div className="subscription-plan_header">
        <span className="skeleton-box skeleton-box--title" />
        <span className="skeleton-box skeleton-box--badge" />
      </div>

      <span className="skeleton-box skeleton-box--price" />

      <div className="subscription-plan_description">
        <span className="skeleton-box skeleton-box--line" />
        <span className="skeleton-box skeleton-box--line" />
        <span className="skeleton-box skeleton-box--line skeleton-box--line-short" />
      </div>

      <div className="subscription-plan_plan">
        {[0, 1, 2].map((i) => (
          <div className="subscription-plan-item" key={i}>
            <span className="skeleton-box skeleton-box--indicator" />
            <span className="skeleton-box skeleton-box--item" />
          </div>
        ))}
      </div>

      <span className="skeleton-box skeleton-box--button" />
    </div>
  );
};

export default SubscriptionPlanSkeleton;
